
import { TranslationKey } from '../types';
import { uiActions } from './categories/ui-actions';
import { navigation } from './categories/fr/navigation';
import { embedding } from './categories/embedding';
import { dialog } from './categories/dialog';
import { playback } from './categories/playback';
import { tracking } from './categories/tracking';
import { speedTesting } from './categories/speed-testing';
import { featureManagement } from './categories/feature-management';
import { autoplayOverlay } from './categories/autoplay-overlay';
import { videoContent } from './categories/video-content';
import { userAccount } from './categories/user-account';
import { userProfile } from './categories/user-profile';
import { VisualElements } from './categories/visual-elements';
import { pagesFr } from './categories/pages-fr';

export const fr = {
  ...uiActions,
  ...navigation,
  ...embedding,
  ...dialog,
  ...playback,
  ...tracking,
  ...speedTesting,
  ...featureManagement,
  ...autoplayOverlay,
  ...videoContent,
  ...userAccount,
  ...userProfile,
  ...VisualElements,
  // French-specific translations for personal profile
  personal: 'Personnel',
  language: 'Langue',
  firstName: 'Prénom',
  lastName: 'Nom',
  email: 'Email',
  company: 'Entreprise',
  currentPassword: 'Mot de Passe Actuel',
  newPassword: 'Nouveau Mot de Passe',
  confirmNewPassword: 'Confirmer le Nouveau Mot de Passe',
  passwordRequirements: 'Exigences de Mot de Passe',
  passwordRequirement1: 'Minimum 8 caractères',
  passwordRequirement2: 'Au moins un chiffre',
  passwordRequirement3: 'Au moins une lettre majuscule',
  security: 'Sécurité',
  ...pagesFr,
} as Record<TranslationKey, string>;
